import { createW3CSignatureIntegrityVerifier } from './w3cModernSignatureIntegrityFactory';

const bbs2023W3CSignatureIntegrity = createW3CSignatureIntegrityVerifier({
  cryptosuite: "bbs-2023",
  name: "Bbs2023W3CSignatureIntegrity",
  derivationPaths: []
});

export { bbs2023W3CSignatureIntegrity };
